import dynamic from 'next/dynamic';
import { ERSFilterProps } from './ErsFilters.types';

export const ErsFilters = dynamic<ERSFilterProps>(() => import('./ErsFilters').then(module => module.default), {
  ssr: false,
});
